import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export function PaymentSuccess() {
  const { t } = useTranslation();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setState("done"); refresh && refresh(); return; }
      } catch { /* keep polling */ }
      if (++tries >= 10) { setState("error"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5" data-testid="payment-success">
      <div className="card-soft max-w-md p-10 text-center">
        {state === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-cyan-dark" /><p className="mt-4 text-slate-600">{t("bill.verifying")}</p></>}
        {state === "done" && <>
          <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
          <h1 className="mt-4 font-heading text-2xl font-extrabold text-navy">{t("bill.successTitle")}</h1>
          <p className="mt-2 text-slate-600">{t("bill.successSub")}</p>
          <Link to="/app/employer"><Button className="mt-6 rounded-full bg-navy text-white" data-testid="go-portal-btn">{t("bill.goPortal")}</Button></Link>
        </>}
        {state === "error" && <>
          <XCircle className="mx-auto h-14 w-14 text-amber-500" />
          <p className="mt-4 text-slate-600">{t("bill.verifying")}</p>
          <Link to="/app/employer/billing"><Button variant="outline" className="mt-6 rounded-full">{t("bill.backBilling")}</Button></Link>
        </>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5" data-testid="payment-cancel">
      <div className="card-soft max-w-md p-10 text-center">
        <XCircle className="mx-auto h-14 w-14 text-slate-400" />
        <h1 className="mt-4 font-heading text-2xl font-extrabold text-navy">{t("bill.canceledTitle")}</h1>
        <p className="mt-2 text-slate-600">{t("bill.canceledSub")}</p>
        <Link to="/app/employer/billing"><Button className="mt-6 rounded-full bg-navy text-white" data-testid="back-billing-btn">{t("bill.backBilling")}</Button></Link>
      </div>
    </div>
  );
}
